/**
 * Graded-slab photography dropped into `public/` for decoration — used as a
 * scattered background texture on auth pages and other low-content screens.
 * Purely decorative (aria-hidden wherever rendered).
 */
export const SLAB_ASSETS: string[] = [
  "/353107778.jpg",
  "/356207195.jpg",
  "/images.jpg",
  "/images (1).jpg",
  "/images (2).jpg",
  "/images (3).jpg",
  "/images (4).jpg",
  "/images (5).jpg",
  "/img060 (2).jpg",
  "/img131.jpg",
];
